import { SessionManagerInterface, StateType as SessionStateType } from '@central-products/interface-session-manager';
import MessageBusTransport from '@central-products/message-transport-bus';
import { INavigationMenu, IModals } from '@myaccount/transport';

export default (function () {
  var transport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MessageBusTransport.getInstance();

  var proxySession = transport.get(SessionManagerInterface);
  var proxyModals = transport.get(IModals);
  var proxyNavigationMenu = transport.get(INavigationMenu);

  proxyNavigationMenu.onReversalWithdrawRequested(function () {
    proxyModals.openReversalWithdraw();
  });

  proxyNavigationMenu.onWithdrawRequested(function () {
    return proxyModals.openWithdraw();
  });

  proxyNavigationMenu.onWithdrawAccountVerificationRequested(function () {
    return proxyModals.openWithdrawAccountVerification();
  });

  proxyNavigationMenu.onGamblingControlsRequested(function () {
    proxyModals.openGamblingControls();
  });

  proxyNavigationMenu.onPokerBalanceTransferRequested(function () {
    return proxyModals.openPokerBalanceTransfer();
  });

  proxySession.onStateChanged(function (_ref) {
    var state = _ref.state;

    if (state !== SessionStateType.LOGGED_IN) {
      proxyModals.close();
    }
  });
});